@switch (type()) {
  @case ('button') {
    @if (!href()) {
      <a
        class="u-button can-decorate"
        [ngClass]="ngClass()"
        [class.active]="isActive()"
        (click)="clickButton($event, onClick())"
        data-button-type="button"
        [attr.data-translate]="attrTranslate()"
      >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </a>
    } @else {
      <!-- THE SAME AS ABOVE BUT WITH THE href -->
      <a
        class="u-button can-decorate"
        [href]="href()"
        [ngClass]="ngClass()"
        [class.active]="isActive()"
        (click)="clickButton($event, onClick())"
        data-button-type="button"
        [attr.data-translate]="attrTranslate()"
      >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </a>
    }
  }
  @case ('link') {
    @if (isExternalLink()) {
      <a
        class="u-button can-decorate"
        [ngClass]="ngClass()"
        target="_blank"
        [href]="href()"
        (click)="onClick() ? clickLink($event, onClick()) : null"
        data-button-type="link"
        [attr.data-translate]="attrTranslate()"
        data-external-link="true"
      >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </a>
    } @else {
      <a
        [href]="href()"
        class="u-button can-decorate"
        [ngClass]="ngClass()"
        [class.active]="isActive()"
        (click)="onClick() ? clickLink($event, onClick()) : null"
        data-button-type="link"
        [attr.data-translate]="attrTranslate()"
        data-external-link="false"
      >
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </a>
    }
  }
}

<ng-template #contentTemplate>
  <ng-content />
</ng-template>
